"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.creativeWorkTaggingMachineCan = exports.creativeWorkTaggingMachineTransition = exports.machine = exports.CREATIVE_WORK_STATES_QA = exports.CREATIVE_WORK_STATES = exports.CREATIVE_WORK_DELIVERED = exports.CREATIVE_WORK_READY_FOR_DELIVERY = exports.CREATIVE_WORK_REVIEW_COMPLETED = exports.CREATIVE_WORK_REVIEW_STARTED = exports.CREATIVE_WORK_REVIEW_AVAILABLE = exports.CREATIVE_WORK_PUBLISHED = exports.CREATIVE_WORK_PUBLISH_ERROR = exports.CREATIVE_WORK_PUBLISH_COMPLETED = exports.CREATIVE_WORK_PUBLISH_STARTED = exports.CREATIVE_WORK_QA_PAUSED = exports.CREATIVE_WORK_QA_STARTED = exports.CREATIVE_WORK_QA_ASSIGNED = exports.CREATIVE_WORK_QA_AVAILABLE = exports.CREATIVE_WORK_TAGGING_PAUSED = exports.CREATIVE_WORK_TAGGING_STARTED = exports.CREATIVE_WORK_TAGGING_ASSIGNED = exports.CREATIVE_WORK_TAGGING_AVAILABLE = exports.CREATIVE_WORK_INITIAL = void 0;
const noop_1 = __importDefault(require("lodash/noop"));
const user_manager_1 = require("../../users/user-manager");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const xstate_1 = require("xstate");
const events_1 = require("xstate-helpers/events");
const Workflow_CreativeWorkConfig_1 = require("../dto/Workflow_CreativeWorkConfig");
exports.CREATIVE_WORK_INITIAL = '[internal] initial';
exports.CREATIVE_WORK_TAGGING_AVAILABLE = 'Tagging Available';
exports.CREATIVE_WORK_TAGGING_ASSIGNED = 'Tagging Assigned';
exports.CREATIVE_WORK_TAGGING_STARTED = 'Tagging Started';
exports.CREATIVE_WORK_TAGGING_PAUSED = 'Tagging Paused';
exports.CREATIVE_WORK_QA_AVAILABLE = 'QA Available';
exports.CREATIVE_WORK_QA_ASSIGNED = 'QA Assigned';
exports.CREATIVE_WORK_QA_STARTED = 'QA Started';
exports.CREATIVE_WORK_QA_PAUSED = 'QA Paused';
exports.CREATIVE_WORK_PUBLISH_STARTED = 'Publish Started';
exports.CREATIVE_WORK_PUBLISH_COMPLETED = 'Publish Completed';
exports.CREATIVE_WORK_PUBLISH_ERROR = 'Publish Error';
exports.CREATIVE_WORK_PUBLISHED = 'Published';
exports.CREATIVE_WORK_REVIEW_AVAILABLE = 'Review Available';
exports.CREATIVE_WORK_REVIEW_STARTED = 'Review Started';
exports.CREATIVE_WORK_REVIEW_COMPLETED = 'Review Completed';
exports.CREATIVE_WORK_READY_FOR_DELIVERY = 'Ready for Delivery';
exports.CREATIVE_WORK_DELIVERED = 'Delivered';
exports.CREATIVE_WORK_STATES = [
    exports.CREATIVE_WORK_INITIAL,
    exports.CREATIVE_WORK_TAGGING_AVAILABLE,
    exports.CREATIVE_WORK_TAGGING_ASSIGNED,
    exports.CREATIVE_WORK_TAGGING_STARTED,
    exports.CREATIVE_WORK_TAGGING_PAUSED,
    exports.CREATIVE_WORK_QA_AVAILABLE,
    exports.CREATIVE_WORK_QA_ASSIGNED,
    exports.CREATIVE_WORK_QA_STARTED,
    exports.CREATIVE_WORK_QA_PAUSED,
    exports.CREATIVE_WORK_PUBLISHED,
    exports.CREATIVE_WORK_PUBLISH_STARTED,
    exports.CREATIVE_WORK_PUBLISH_COMPLETED,
    exports.CREATIVE_WORK_PUBLISH_ERROR,
    exports.CREATIVE_WORK_REVIEW_AVAILABLE,
    exports.CREATIVE_WORK_REVIEW_STARTED,
    exports.CREATIVE_WORK_REVIEW_COMPLETED,
    exports.CREATIVE_WORK_READY_FOR_DELIVERY,
    exports.CREATIVE_WORK_DELIVERED,
];
exports.CREATIVE_WORK_STATES_QA = [
    exports.CREATIVE_WORK_QA_AVAILABLE,
    exports.CREATIVE_WORK_QA_ASSIGNED,
    exports.CREATIVE_WORK_QA_STARTED,
    exports.CREATIVE_WORK_QA_PAUSED,
    exports.CREATIVE_WORK_REVIEW_AVAILABLE,
    exports.CREATIVE_WORK_REVIEW_COMPLETED,
];
function getUserId(user) {
    return 'relationship.employeeId' in user ? user['relationship.employeeId'] : user.id;
}
exports.machine = (0, xstate_1.createMachine)({
    initial: exports.CREATIVE_WORK_INITIAL,
    states: {
        [exports.CREATIVE_WORK_INITIAL]: {
            on: {
                CREATE: [
                    {
                        cond: 'hasAssigneeSet',
                        target: exports.CREATIVE_WORK_TAGGING_ASSIGNED,
                        actions: [
                            'setInitialConfig',
                            'setAssigneeFromEvent',
                            'addAssigneeTagger',
                        ],
                    },
                    {
                        target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                        actions: 'setInitialConfig',
                    },
                ],
            },
        },
        [exports.CREATIVE_WORK_TAGGING_AVAILABLE]: {
            on: {
                SELF_ASSIGN: {
                    target: exports.CREATIVE_WORK_TAGGING_ASSIGNED,
                    actions: ['setAssigneeFromEvent', 'addAssigneeTagger'],
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_ASSIGNED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    actions: 'removeAssignee',
                },
                START: {
                    target: exports.CREATIVE_WORK_TAGGING_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_STARTED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    actions: 'removeAssignee',
                },
                PAUSE: {
                    target: exports.CREATIVE_WORK_TAGGING_PAUSED,
                },
                TAGGING_COMPLETE: {
                    target: exports.CREATIVE_WORK_QA_AVAILABLE,
                    actions: 'removeAssignee',
                },
                CONTINUE_STARTED: {
                    actions: noop_1.default,
                },
            },
        },
        [exports.CREATIVE_WORK_TAGGING_PAUSED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_TAGGING_AVAILABLE,
                    actions: 'removeAssignee',
                },
                RESUME: {
                    target: exports.CREATIVE_WORK_TAGGING_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_QA_AVAILABLE]: {
            on: {
                SELF_ASSIGN: {
                    target: exports.CREATIVE_WORK_QA_ASSIGNED,
                    actions: ['setAssigneeFromEvent', 'addAssigneeQA'],
                },
            },
        },
        [exports.CREATIVE_WORK_QA_ASSIGNED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_QA_AVAILABLE,
                    actions: 'removeAssignee',
                },
                START: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_QA_STARTED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_QA_AVAILABLE,
                    actions: 'removeAssignee',
                },
                PAUSE: {
                    target: exports.CREATIVE_WORK_QA_PAUSED,
                },
                REVIEW_MAKE_AVAILABLE: {
                    target: exports.CREATIVE_WORK_REVIEW_AVAILABLE,
                    cond: 'workflowNeedsReview',
                    actions: 'removeAssignee',
                },
                PUBLISH_START: {
                    target: exports.CREATIVE_WORK_PUBLISH_STARTED,
                    cond: 'workflowCanPublish',
                },
                RETURN_TO_TAGGER: {
                    target: exports.CREATIVE_WORK_TAGGING_PAUSED,
                    actions: 'setAssigneeToLastTagger',
                },
                CONTINUE_STARTED: {
                    // https://github.com/statelyai/xstate/issues/2825
                    actions: noop_1.default,
                },
            },
        },
        [exports.CREATIVE_WORK_QA_PAUSED]: {
            on: {
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_QA_AVAILABLE,
                    actions: 'removeAssignee',
                },
                RESUME: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_PUBLISH_STARTED]: {
            on: {
                PUBLISH_SUCCESS: {
                    target: exports.CREATIVE_WORK_PUBLISHED,
                },
                PUBLISH_SUCCESS_DESCRIPTOR: {
                    target: exports.CREATIVE_WORK_READY_FOR_DELIVERY,
                    actions: 'removeAssignee',
                },
                PUBLISH_ERROR: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_READY_FOR_DELIVERY]: {
            on: {
                DELIVER: {
                    target: exports.CREATIVE_WORK_DELIVERED,
                },
                DELIVER_REJECT: {
                    target: exports.CREATIVE_WORK_QA_STARTED,
                },
            },
        },
        [exports.CREATIVE_WORK_REVIEW_AVAILABLE]: {
            on: {
                SELF_ASSIGN: {
                    target: exports.CREATIVE_WORK_REVIEW_STARTED,
                    actions: ['setAssigneeFromEvent', 'addAssigneeReview'],
                },
            },
        },
        [exports.CREATIVE_WORK_REVIEW_STARTED]: {
            on: {
                REVIEW_REJECT: {
                    target: exports.CREATIVE_WORK_QA_ASSIGNED,
                    actions: 'setAssigneeToLastQAIfRejected',
                },
                REVIEW_APPROVE: {
                    target: exports.CREATIVE_WORK_REVIEW_COMPLETED,
                    actions: 'setAssigneeToLastQAIfApproved',
                },
                RELEASE_TASK: {
                    target: exports.CREATIVE_WORK_REVIEW_AVAILABLE,
                    actions: 'removeAssignee',
                },
            },
        },
        [exports.CREATIVE_WORK_REVIEW_COMPLETED]: {
            on: {
                PUBLISH_START: {
                    target: exports.CREATIVE_WORK_PUBLISH_STARTED,
                    cond: 'workflowCanPublish',
                },
                CONTINUE_STARTED: {
                    // https://github.com/statelyai/xstate/issues/2825
                    actions: noop_1.default,
                },
            },
        },
        [exports.CREATIVE_WORK_PUBLISHED]: {
            type: 'final',
        },
        [exports.CREATIVE_WORK_DELIVERED]: {
            type: 'final',
        },
    },
}, {
    actions: {
        setAssigneeFromEvent: (0, xstate_1.assign)({
            assignee: (_, e) => {
                if (e.type === 'CREATE') {
                    return e.data.assignee;
                }
                if ('user' in e) {
                    return getUserId(e.user);
                }
                else {
                    throw new Error(`Cannot set assignee from event:\n` + JSON.stringify(e, null, 2));
                }
            },
        }),
        setAssigneeToLastTagger: (0, xstate_1.assign)({
            assignee: ({ config }) => {
                const assigneesTagger = (config === null || config === void 0 ? void 0 : config.assigneesTagger) || [];
                (0, tiny_invariant_1.default)(assigneesTagger.length, 'No previous Tagger assignees saved');
                return assigneesTagger[assigneesTagger.length - 1];
            },
        }),
        removeAssignee: (0, xstate_1.assign)({
            assignee: _ => null,
        }),
        setInitialConfig: (0, xstate_1.assign)({
            config: (ctx, e) => {
                (0, events_1.invariantEvent)(e, 'CREATE');
                const inputConfig = ctx.config;
                return (0, Workflow_CreativeWorkConfig_1.buildWorkflowCreativeWorkConfig)({
                    ...inputConfig,
                    reviewPassed: false,
                    assigneesTagger: e.data.assignee ? [e.data.assignee] : [],
                    assigneesQA: [],
                    assigneesReview: [],
                });
            },
        }),
        addAssigneeTagger: (0, xstate_1.assign)({
            config: ({ assignee, config }) => {
                (0, tiny_invariant_1.default)(assignee, 'Context does not have assignee');
                return {
                    ...config,
                    assigneesTagger: [...config.assigneesTagger, assignee],
                };
            },
        }),
        addAssigneeQA: (0, xstate_1.assign)({
            config: ({ assignee, config }) => {
                (0, tiny_invariant_1.default)(assignee, 'Context does not have assignee');
                return {
                    ...config,
                    assigneesQA: [...config.assigneesQA, assignee],
                };
            },
        }),
        addAssigneeReview: (0, xstate_1.assign)({
            config: ({ assignee, config }) => {
                (0, tiny_invariant_1.default)(assignee, 'Context does not have assignee');
                return {
                    ...config,
                    assigneesReview: [...config.assigneesReview, assignee],
                };
            },
        }),
        setAssigneeToLastQAIfApproved: (0, xstate_1.assign)({
            config: ({ assignee, config }) => {
                (0, tiny_invariant_1.default)(assignee, 'Context does not have assignee');
                return {
                    ...config,
                    reviewPassed: true,
                };
            },
        }),
        setAssigneeToLastQAIfRejected: (0, xstate_1.assign)({
            config: ({ assignee, config }) => {
                (0, tiny_invariant_1.default)(assignee, 'Context does not have assignee');
                return {
                    ...config,
                    reviewPassed: false,
                };
            },
        }),
    },
    guards: {
        hasAssigneeSet: (_, e) => {
            (0, events_1.invariantEvent)(e, 'CREATE');
            return !!e.data.assignee;
        },
        workflowNeedsReview: ctx => {
            return !!ctx.config.reviewRequired && !ctx.config.reviewPassed;
        },
        workflowCanPublish: ctx => {
            return !ctx.config.reviewRequired || !!ctx.config.reviewPassed;
        },
    },
});
function creativeWorkTaggingMachineTransition(workflow, event) {
    var _a, _b, _c;
    const context = {
        workflow,
        config: (0, Workflow_CreativeWorkConfig_1.buildWorkflowCreativeWorkConfig)(workflow.workflowConfig || {}),
        assignee: workflow.assignee,
    };
    // if must check assignee
    const userId = typeof event === 'object' && 'user' in event && event.user
        ? 'relationship.employeeId' in ((_a = event) === null || _a === void 0 ? void 0 : _a.user)
            ? (_b = event) === null || _b === void 0 ? void 0 : _b.user['relationship.employeeId']
            : (_c = event) === null || _c === void 0 ? void 0 : _c.user.id
        : null;
    // Retrieve user to check role. If ADMIN, allow release
    const myIDUser = user_manager_1.UserManager.listAllMyID().find(u => u['relationship.employeeId'] === userId);
    const isAdmin = myIDUser === null || myIDUser === void 0 ? void 0 : myIDUser.roles.map(r => r.name.toLowerCase()).includes('admin');
    const isAdminReleaseEvent = event.type === 'RELEASE_TASK' && isAdmin;
    // only allow transition regardless of asignee if release
    if (isAdminReleaseEvent)
        return exports.machine.transition(workflow.state, event, context);
    if (typeof event === 'object' && 'user' in event && event.user && workflow.assignee) {
        const assigneeValid = workflow.assignee === userId;
        if (!assigneeValid) {
            // resolve with unchanged state
            return exports.machine.resolveState(xstate_1.State.from(workflow.state, context));
        }
    }
    return exports.machine.transition(workflow.state, event, context);
}
exports.creativeWorkTaggingMachineTransition = creativeWorkTaggingMachineTransition;
function creativeWorkTaggingMachineCan(workflow, event) {
    return !!creativeWorkTaggingMachineTransition(workflow, event).changed;
}
exports.creativeWorkTaggingMachineCan = creativeWorkTaggingMachineCan;
//# sourceMappingURL=creative-work-tagging.machine.js.map